module.exports = "<h1>Logout</h1>\n<p>You have successfully logged out.</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.html
// module id = ./src/app/components/logout/logout.component.html
// module chunks = main